<template>
  <div
    v-show="visible"
    class="resume-order-float"
  >
    <div
      class="resume-order-float__btn"
      @click.stop="togglePanel"
    >
      续填订单
    </div>
    <div
      v-show="showPanel"
      class="resume-order-float__panel"
    >
      <button
        type="button"
        class="resume-order-float__action resume-order-float__action--primary"
        @click.stop="goResume"
      >
        去续填
      </button>
      <button
        type="button"
        class="resume-order-float__action resume-order-float__action--danger"
        @click.stop="cancelResume"
      >
        取消续填
      </button>
    </div>
  </div>
</template>

<script>
import { Dialog, Toast } from "vant";
import {
  clearCompleteOrderDraft,
  getCompleteOrderDraft,
  hasCompleteOrderDraft,
  onCompleteOrderDraftChange,
} from "@/utils/completeOrderDraft";

export default {
  name: "CompleteOrderResumeFloat",
  data() {
    return {
      hasDraft: false,
      showPanel: false,
      unbindDraftChange: null,
    };
  },
  computed: {
    visible() {
      if (!this.hasDraft) {
        return false;
      }
      if (this.$route.path === "/Login") {
        return false;
      }
      // 完成订单页内不展示悬浮窗
      if (this.$route.path === "/CompleteOrder") {
        return false;
      }
      return true;
    },
  },
  watch: {
    $route() {
      this.showPanel = false;
      this.refreshDraftState();
    },
    visible(val) {
      if (!val) {
        this.showPanel = false;
      }
    },
  },
  mounted() {
    if (this.$el && this.$el.parentNode !== document.body) {
      document.body.appendChild(this.$el);
    }
    this.refreshDraftState();
    this.unbindDraftChange = onCompleteOrderDraftChange(this.refreshDraftState);
    document.addEventListener("click", this.onDocumentClick);
  },
  beforeDestroy() {
    document.removeEventListener("click", this.onDocumentClick);
    if (this.unbindDraftChange) {
      this.unbindDraftChange();
    }
    if (this.$el && this.$el.parentNode) {
      this.$el.parentNode.removeChild(this.$el);
    }
  },
  methods: {
    refreshDraftState() {
      this.hasDraft = hasCompleteOrderDraft();
    },
    togglePanel() {
      this.showPanel = !this.showPanel;
    },
    onDocumentClick() {
      this.showPanel = false;
    },
    goResume() {
      this.showPanel = false;
      const draft = getCompleteOrderDraft();
      const currentUserId = localStorage.getItem("userId");
      if (
        !draft ||
        !draft.orderId ||
        !currentUserId ||
        String(draft.userId) !== String(currentUserId)
      ) {
        this.refreshDraftState();
        Toast("暂无续填内容");
        return;
      }
      sessionStorage.setItem("orderId", String(draft.orderId));
      this.$router.push({
        path: "/CompleteOrder",
        query: {
          orderId: draft.orderId,
          goBackUrl: draft.goBackUrl || "/OrderList",
          type: draft.goBackType != null ? draft.goBackType : "2",
          resumeDraft: "1",
        },
      });
    },
    cancelResume() {
      this.showPanel = false;
      Dialog.confirm({
        title: "提示",
        message: "取消后将删除本地续填记忆，是否继续？",
      })
        .then(() => {
          clearCompleteOrderDraft();
          this.refreshDraftState();
          Toast.success("已取消续填");
        })
        .catch(() => {});
    },
  },
};
</script>

<style scoped>
.resume-order-float {
  position: fixed;
  left: 0;
  top: 42%;
  z-index: 3000;
  display: flex;
  flex-direction: row;
  align-items: stretch;
  text-align: left;
  pointer-events: none;
}

.resume-order-float__btn {
  pointer-events: auto;
  writing-mode: vertical-rl;
  letter-spacing: 0.12em;
  padding: 12px 8px;
  background: #1989fa;
  color: #fff;
  font-size: 13px;
  line-height: 1.2;
  border-radius: 0 8px 8px 0;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.2);
  user-select: none;
  cursor: pointer;
}

.resume-order-float__panel {
  pointer-events: auto;
  display: flex;
  flex-direction: column;
  justify-content: center;
  margin-left: 6px;
  background: #fff;
  border-radius: 8px;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.18);
  overflow: hidden;
  min-width: 88px;
}

.resume-order-float__action {
  border: none;
  background: #fff;
  padding: 12px 14px;
  font-size: 14px;
  cursor: pointer;
  line-height: 1.2;
}

.resume-order-float__action + .resume-order-float__action {
  border-top: 1px solid #ebedf0;
}

.resume-order-float__action--primary {
  color: #1989fa;
}

.resume-order-float__action--danger {
  color: #ee0a24;
}
</style>
